import {post,post_utf} from '@/utils/request';
import {erpserver,oaserver,erpplatserver} from '@/utils/baseUrl';
    export async function getRelateOrderDetailList(params) {
        return post_utf(erpserver+'/sellinvoice/getRelateOrderDetailList',params,true)
    }
export async function saveSellPendingShipment(params) {
    return post_utf(erpserver+'/sellinvoice/saveSellPendingShipment',params,true)
}
export async function getPendingShipmentList(params) {
    return post_utf(erpserver+'/sellinvoice/getPendingShipmentList',params,true)
}
//
export async function uploadAttachment(params) {
    return post_utf(erpserver+'/sellinvoice/uploadAttachment',params,true)
}
//上传图片-new
export async function uploadInvoice(params) {
    return post(erpplatserver+'/system/uploadInvoice',params,false);
}
export async function getSubCustomers(params) {
    return post(oaserver+'/oacrm/getSubCustomers', params,true);
}
export async function getKhBaseInfo(params) {
    return post(oaserver+'/oacrm/getKhBaseInfo', params,true);
}
//获取交易公司
export async function getCompanyList(params) {
    return post(oaserver+'/oacurrency/getCompanyList', params, true);
}
//查询列表接口
export async function queryInvoicedAndRedInvoices(params) {
    return post(erpserver+'/sellinvoice/queryInvoicedAndRedInvoices',params,true)
}
//查询列表接口(已开票、冲红
export async function listInvoice(params) {
    return post(erpserver+'/sellinvoice/listInvoice',params,true)
}
//查询列表接口
export async function listBeforeInvoice(params) {
    return post(erpserver+'/sellinvoice/listBeforeInvoice',params,true)
}
//查询列表接口
export async function listAfterInvoice(params) {
    return post(erpserver+'/sellinvoice/listAfterInvoice',params,true)
}
//保存／删除接口
export async function saveInvoice(params) {
    return post(erpserver+'/sellinvoice/saveInvoice',params,true)
}
//提交
export async function submit(params) {
    return post(erpserver+'/sellinvoice/submit',params,true)
}
//删除提交
export async function cancelsubmit(params) {
    return post(erpserver+'/sellinvoice/cancelsubmit',params,true)
}
//转入待开票列表
export async function reset(params) {
    return post(erpserver+'/sellinvoice/reset',params,true)
}
//转线下开票
export async function offline(params) {
    return post(erpserver+'/sellinvoice/offline',params,true)
}
//开票类型
export async function invoicetype(params) {
    return post(oaserver+'/oacrm/invoicetype',params,true)
}
//保存开票资料
export async function addKhBankAndZh(params) {
    return post(oaserver+'/oacrm/addKhBankAndZh',params,true)
}
//单位换算
export async function getUnitList(params) {
    return post(erpserver+'/currency/getUnitList',params,true)
}
//批量编辑待提交
export async function updInvoice(params) {
    return post(erpserver+'/sellinvoice/updInvoice',params,true)
}
//重发
export async function sendMsg(params) {
    return post(erpserver+'/sellinvoice/sendMsg',params,true)
}
